import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SelectionModel} from '@angular/cdk/collections';
import {HttpService} from 'src/app/core';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-connect-property-dialog',
  templateUrl: './connect-property-dialog.component.html',
  styleUrls: ['./connect-property-dialog.component.scss']
})
export class ConnectPropertyDialogComponent implements OnInit {

  floorPlan: any;
  project: any;
  properties = [];
  dataSource = [];
  selection = new SelectionModel<any>(true, []);
  displayedColumns = ['select', 'unit', 'config', 'building', 'price', 'status'];

  filterParams = {
    unitNum: null,
    bedRoom: 0,
    bathRoom: 0,
    carParking: 0
  };

  constructor(
    private httpService: HttpService,
    private dialogRef: MatDialogRef<any>,
    private toastrService: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
    this.floorPlan = this.data.floorPlan;
    this.project = this.data.project;
    this.properties = this.data.properties || [];

    this.properties.map(property => {
      property.floorPlan && property.floorPlan.id == this.floorPlan.id ? property.isChecked = true : property.isChecked = false;
    });

    this.dataSource = this.properties;
  }

  filterProperties() {
    this.dataSource = this.properties.filter(property => {
      return true
    });
 
    this.dataSource = this.dataSource.filter(property => {
      if (this.filterParams.bedRoom == 0) {
        return true;
      }
      else if (property.bedRoom == this.filterParams.bedRoom) {
        return true;
      }
      else if(this.filterParams.bedRoom == 5 && property.bedBoom >= 5) {
        return true;
      }
      else {
        return false
      }
    });
  
    this.dataSource = this.dataSource.filter(property => {
      if (this.filterParams.bathRoom == 0) {
        return true;
      }
      else if (property.bathRoom == this.filterParams.bathRoom) {
        return true;
      }
      else if(this.filterParams.bathRoom == 5 && property.bathRoom >= 5) {
        return true;
      }
      else {
        return false
      }
    });

    this.dataSource = this.dataSource.filter(property => {
      if (this.filterParams.carParking == 0) {
        return true;
      }
      else if (property.carParking == this.filterParams.carParking) {
        return true;
      }
      else if(this.filterParams.carParking == 5 && property.carParking >= 5) {
        return true;
      }
      else {
        return false
      }
    });

 


    // this.dataSource = this.properties.filter(property => {
    //   if (this.filterParams.unitNum && !property.unitNum.toLowerCase().includes(this.filterParams.unitNum.toLowerCase())) {
    //     return false;
    //   }
    //   if (this.filterParams.bedRoom && ((this.filterParams.bedRoom == 5 && property.bedBoom < 5) || (property.bedRoom != this.filterParams.bedRoom))) {
    //     console.log(property.bedRoom);
    //     return false;
    //   }
    //   if (this.filterParams.bathRoom && ((this.filterParams.bathRoom == 5 && property.bathRoom < 5) || (property.bathRoom != this.filterParams.bathRoom))) {
    //     return false;
    //   }
    //   if (this.filterParams.carParking && ((this.filterParams.carParking == 5 && property.carParking < 5) || (property.carParking != this.filterParams.carParking))) {
    //     return false;
    //   }

    //   return true;
    // });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }

  masterToggle() {
    // this.isAllSelected()
    //   ? this.selection.clear()
    //   : this.dataSource.forEach(row => this.selection.select(row));
    if (this.isAllSelected()) {
      this.selection.clear();
      this.dataSource.forEach((property) => {
        property.isChecked = false;
      });

    } else {
      this.dataSource.forEach((property) => {
        this.selection.select(property);
        property.isChecked = true;
      });
    }
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  cancel() {
    this.dialogRef.close();
  }

  submit() {
    const selectedPropertyIds = this.properties.filter(property => property.isChecked).map(property => property.id);

    const fd = new FormData();
    fd.append('propertyIds', selectedPropertyIds.toString());
    fd.append('projectId', this.project.id);

    this.httpService.editFloorPlanNotes(fd, this.floorPlan.id).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.toastrService.success('The floorplan has been updated.');
        this.dialogRef.close({floorPlan: res.data, propertyIds: selectedPropertyIds});
      } else {
        this.toastrService.error('Failed to update this floorplan.');
      }
    });
  }

  getProjectBuildingName(property) {
    const buliding = this.project.buildings.find(building => {
      return building.properties.find(p => p.id == property.id);
    });

    if (!buliding) {
      return '';
    }
    return buliding.name;
  }

  getStatusLabel(status) {
    switch (status) {
      case 0:
        return 'unavailable';
      case 1:
        return 'available';
      case 2:
        return 'reserved'; // eoi
      case 3:
        return 'reserved';
      case 4:
        return 'processing'; // exchanage conditional
      case 5:
        return 'processing'; // unconditional
      case 6:
        return 'sold';
    }
  }
}
